import {
  Directive,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  HostBinding,
} from '@angular/core';

@Directive({
  selector:
    '[pgSuffixIcon], pg-suffix-icon, [gritSuffixIcon], grit-suffix-icon',
  exportAs: 'pgSuffixIcon, gritSuffixIcon',
})
export class PgSuffixIconDirective implements OnChanges {
  @HostBinding('class.pg-suffix-icon') _classIcon = true;
  @Input() visible = false;

  @Output() visibleChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public elementRef: ElementRef) {}

  // When the icon's visibility changed emit an event.
  ngOnChanges(changes: SimpleChanges) {
    if (changes.visible) {
      this.visibleChanged.emit(changes.visible.currentValue);
    }
  }
}
